import React, { createContext, useContext, useState, useCallback } from "react";

// [english, te reo māori]
const STRINGS = {
  "nav.home": ["Home", "Kāinga"],
  "nav.store": ["Store", "Toa"],
  "nav.catalog": ["Catalog", "Rārangi"],
  "nav.mysteryBoxes": ["Mystery Boxes", "Pouaka Muna"],
  "nav.crushClub": ["Cutting Crush Club ♡", "Karapu Kōkiri ♡"],
  "nav.privatePickings": ["Visit Heritage", "Toro mai ki Heritage"],
  "nav.fairitage": ["Fairitage Sale", "Hoko Fairitage"],
  "nav.ourFarm": ["Our Farm", "Tō Mātou Pāmu"],
  "nav.breedersClub": ["Breeders Club", "Karapu Kaiwhakatipu"],
  "nav.bloomClub": ["Bloom Club", "Karapu Puāwai"],
  "nav.start": ["Start", "Tīmata"],
  "nav.cart": ["Cart", "Kete"],
  "nav.myHq": ["My HQ", "Taku HQ"],
  "nav.signIn": ["sign in", "takiuru"],
  "nav.hi": ["Hi", "Kia ora"],
  "nav.there": ["there", "e hoa"],
  "nav.openHq": ["open My HQ", "huakina Taku HQ"],
  "strip.familyGrown": ["✦ FAMILY GROWN SINCE 1932 ✦", "✦ HE WHĀNAU WHAKATIPU MAI I 1932 ✦"],

  "footer.tagline": [
    "Heritage Dahlias, a family flower farm in Aotearoa, growing the legacy of our Nana Jean, born 1932.",
    "Ko Heritage Dahlias, he pāmu putiputi whānau i Aotearoa, e whakatipu ana i te taonga tuku iho a tō mātou Nana Jean, i whānau mai i 1932.",
  ],
  "footer.pages": ["PAGES", "NGĀ WHĀRANGI"],
  "footer.getInTouch": ["GET IN TOUCH", "WHAKAPĀ MAI"],
  "footer.sendMessage": ["Send us a message →", "Tukua mai he karere →"],
  "footer.startPage": ["← Heritage start page", "← Whārangi tīmatanga"],
  "footer.legacy": ["Carrying on Nana Jean's legacy.", "E kawe tonu ana i te taonga tuku iho a Nana Jean."],
  "footer.privacy": ["Privacy", "Tūmataiti"],
  "footer.terms": ["Terms", "Ngā Ture"],
  "footer.shipping": ["Shipping", "Tukunga"],
  "footer.returns": ["Returns", "Whakahokinga"],
  "footer.ip": ["IP", "IP"],
  "footer.grower": ["Grower", "Kaiwhakatipu"],

  "hq.nav.dashboard": ["Dashboard", "Papatohu"],
  "hq.nav.selfAudit": ["Customer Self Audit", "Arotake Whaiaro"],
  "hq.nav.privateBookings": ["Private Bookings", "Ngā Tohu Motuhake"],
  "hq.nav.priorityOrder": ["Priority Order", "Ota Matua"],
  "hq.nav.myOrders": ["My Orders", "Aku Ota"],
  "hq.nav.fairSale": ["Fairitage Sale", "Hoko Fairitage"],
  "hq.nav.catalogue": ["Catalogue", "Rārangi"],
  "hq.nav.myPicks": ["Choose My Tubers", "Kōwhiria Aku Pūtake"],
  "hq.nav.crushes": ["My Crushes ♡", "Aku Kōkiri ♡"],
  "hq.nav.tickets": ["My Tickets", "Aku Tīkiti"],
  "hq.nav.myProfile": ["My Profile", "Taku Kōtaha"],
  "hq.nav.credits": ["Credits & Vouchers", "Moni Whiwhi & Pōkeka"],
  "hq.nav.statements": ["Statements", "Ngā Tauākī"],
  "hq.nav.contact": ["Contact Heritage", "Whakapā ki a Heritage"],
  "hq.portal": ["Customer Portal", "Tomokanga Kiritaki"],
  "hq.external": ["External", "Waho"],
  "hq.bloomClubAccount": ["Bloom Club Account", "Pūkete Karapu Puāwai"],
  "hq.bloomId": ["Bloom ID", "Tuakiri Puāwai"],
  "hq.signOut": ["Sign out", "Takiputa"],
  "hq.title": ["✦ Heritage Headquarters", "✦ Te Tari Matua o Heritage"],
  "hq.welcome": ["Welcome back,", "Nau mai anō,"],
  "hq.gladHere": [
    "We're so glad you're here. Pick a tile to get started.",
    "He hari mātou i tō taenga mai. Kōwhiria he tīwae hei tīmata.",
  ],
  "hq.yourAccount": ["✦ Your account", "✦ Tō pūkete"],
  "hq.sub.dashboard": ["Your Heritage account at a glance", "Tō pūkete Heritage i te tirohanga kotahi"],
  "hq.sub.selfAudit": ["Check payments and report a missing order", "Tirohia ngā utu, pūrongotia he ota ngaro"],
  "hq.sub.orders": ["Current orders, historical orders & tracking", "Ngā ota o nāianei, o mua & te whai"],
  "hq.sub.privateBookings": ["Your private picking on the farm", "Tō kōhi motuhake i te pāmu"],
  "hq.sub.priorityOrder": ["Review and confirm your order with us", "Arotake, whakaū i tō ota"],
  "hq.sub.fairSale": ["Join live allocations and wishlist events", "Uru ki ngā tuwhanga ora me ngā hui rārangi hiahia"],
  "hq.sub.catalogue": ["Browse every variety and build your wishlist", "Tirotiro i ia momo, hangaia tō rārangi hiahia"],
  "hq.sub.myPicks": ["Select varieties for eligible open orders", "Kōwhiria ngā momo mō ngā ota tuwhera e āhei ana"],
  "hq.sub.crushes": ["Follow your cutting requests", "Whai i ō tono tapahanga"],
  "hq.sub.tickets": ["Your Open Day tickets & gate codes", "Ō tīkiti Rā Tuwhera"],
  "hq.sub.profile": ["Manage your account, addresses and password", "Whakahaere i tō pūkete, wāhi noho me te kupuhipa"],
  "hq.sub.credits": ["Account credit, gift vouchers and balances", "Moni pūkete, pōkeka koha me ngā toenga"],
  "hq.sub.statements": ["Invoices, receipts and payment history", "Ngā nama, rīhīti me te hītori utu"],
  "hq.sub.contact": ["Message the Heritage team directly", "Tukua he karere tōtika ki te tira Heritage"],
  "hq.sub.bloomClub": ["Manage your Bloom Club grower or subscriber account", "Whakahaere i tō pūkete kaiwhakatipu, kaiohauru rānei o te Karapu Puāwai"],
  "hq.sub.bloomId": ["Scan the unique plant tag and track your mystery tuber blooms", "Matawai te tūtohu tipu ahurei, whāia hoki ō puāwai pūtake muna"],
};

const LanguageContext = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try { return localStorage.getItem("heritage-lang") === "mi" ? "mi" : "en"; }
    catch { return "en"; }
  });
  const setLang = useCallback((next) => {
    setLangState(next);
    try { localStorage.setItem("heritage-lang", next); } catch { /* ignore */ }
  }, []);
  const t = useCallback(
    (key) => {
      const pair = STRINGS[key];
      if (!pair) return key;
      return lang === "mi" ? pair[1] : pair[0];
    },
    [lang],
  );
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
